<template>
    <div style="background-color: white;color: black;">
        <mt-header title="行程表"></mt-header>
        <h2 style="color: black;padding: 10px;">{{this.$route.query.date*1000 | date('%Y-%m-%d')}} - 行程表</h2>
        <div style="    padding: 15px;
    font-size: 16px;">
            <div style="margin-bottom: 10px;"><span style="border-bottom: 1px ridge black;">請假申請 : </span></div>
            <div v-for="item in staffLeaveList">
                <div style="margin-bottom: 10px;">員工 : <span>{{item.staffName}}</span> <span style="color: red;">{{item.typeStr}}</span>
                    <span style="color: red;">{{item.dayStr}}</span></div>
            </div>

            <div style="margin-top:30px;margin-bottom: 10px;"><span style="border-bottom: 1px ridge black;">投保預約 : </span></div>
            <div v-for="item in overseaList">
                <div style="margin-bottom: 10px;">預約人 : <span>{{item.partnerName}}</span></div>
                <div style="margin-bottom: 10px;">時間 : <span style="color: red;">{{item.dayStr}}</span></div>
                <div style="margin-bottom: 10px;">認證專員 : <span>{{item.staffName}}</span></div>
            </div>

            <div style="margin-top:30px;margin-bottom: 10px;"><span style="border-bottom: 1px ridge black;">會議 : </span></div>
            <div v-for="item in roomBooking">
                <div style="margin-bottom: 10px;">{{item.dayStr}}</div>

            </div>

            <div style="margin-top:30px;margin-bottom: 10px;"><span style="border-bottom: 1px ridge black;">假期 : </span></div>
            <div v-for="item in holidayList">
                <div style="margin-bottom: 10px;">{{item.dayStr}}</div>

            </div>
        </div>


    </div>
</template>

<script>
    import "mint-ui/lib/style.css";
    import { Header } from 'mint-ui';
    import {wechatCalendar} from '../../api/api'

    export default {
        data() {
            //驗證登錄名字
            return {
                staffLeaveList :[],
                overseaList:[],
                holidayList:[],
                roomBooking:[]
            }
        },
        methods: {
            wechatCalendar(){
                    let params={date:this.$route.query.date};
                    return wechatCalendar(params).then(res=>{
                        if(res.errcode==200){
                            res.data.forEach(v=>{
                                if(v.type==0){
                                    this.staffLeaveList.push(v);
                                }else if(v.type==2){
                                    this.overseaList.push(v);
                                }else if(v.type==3){
                                    this.holidayList.push(v);
                                }else if(v.type==4){
                                    this.roomBooking.push(v);
                                }
                            });
                        }else{
                            this.$message.error(res.errmsg);
                        }
                    }).catch((error)=>{
                        console.log("wechatCalendar Error");
                    });
                }
        },
        mounted() {
            this.wechatCalendar();
        },
        computed: {

        },
        activated(){

        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/views/wechat/Hr.vue